export enum ClassificationCodeEnum {
  ClassCodeTous = '#TOUS',
  ClassCodeAll = '#ALL'
}
export class ClassificationHelper {
  public static Compare(classCodeA: string, classCodeB: string) {
    return classCodeA.toUpperCase() == classCodeB.toUpperCase();
  }

  public static IsTous(classificationCode: string) {
    return ClassificationHelper.ClassCodesTous.includes(classificationCode.toUpperCase());
  }

  public static ClassCodesTous: string[] = [ClassificationCodeEnum.ClassCodeAll, ClassificationCodeEnum.ClassCodeTous];
}
